import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { compose } from 'recompose';

import { withAuthorization, withEmailVerification } from '../Session';
import { UserList, UserItem } from '../Users';
import { ADMIN } from '../../constants/roles';
import { ADMIN_DETAILS, ADMIN as ROUTES_ADMIN } from '../../constants/routes';

const AdminPage = () => (
  <div>
    <h1>Admin</h1>
    <p>The Admin Page is accessible by every signed in admin user.</p>

    <Switch>
      <Route exact path={ADMIN_DETAILS} component={UserItem} />
      <Route exact path={ROUTES_ADMIN} component={UserList} />
    </Switch>
  </div>
);

const condition = authUser => authUser && !!authUser.role === ADMIN;

export default compose(
  withEmailVerification,
  withAuthorization(condition)
)(AdminPage);
